import { Component, OnInit, TemplateRef, EventEmitter, Output } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserService } from '../../../../services/userService/user.service';
import { environment } from '../../../../../environments/environment';
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { ToastrService } from "ngx-toastr";
import { Router, ActivatedRoute } from "@angular/router";
import { RolePermissionServiceService } from "../../../../services/rolepermission/role-permission-service.service";
import { RolePermissionService } from "../../../../appService/role-permission.service";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: 'app-orderapprovepdf',
  templateUrl: './orderapprovepdf.component.html',
  styleUrls: ['./orderapprovepdf.component.css']
})
export class OrderapprovepdfComponent implements OnInit {
  @Output() clearEvent = new EventEmitter<void>();
  permission: any;
  id: any;
  active: string;
  url: string;
  dft_icn: string;
  downloadurl: string;
  modalRef: any;
  filesname: any;
  file: any;
  userRId: any;
  orderdoc: any;
  pdfname: any;
  delNameDel: boolean;
  filesid: any;
  createdBy: any;
  createdDate: any;
  searchword: any;
  createdTime: any;

  constructor(
    private UserService: UserService,
    private route: ActivatedRoute,
    private service: RolePermissionService,
    private roleservice: RolePermissionServiceService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private http: HttpClient,
  ) {
    this.active = localStorage.getItem("active_id");
    let decid = localStorage.getItem("editOid");
    decid = decid
      .toString()
      .replace("Ar1t", "=")
      .replace("FGH", "/")
      .replace("THD", "+");
    this.id = this.UserService.decryptData(decid);
    let permi = JSON.parse(localStorage.getItem("Permission"));
    this.permission = this.UserService.decryptData(permi);
  }

  ngOnInit(): void {
    this.url = environment.tempimage;
    this.downloadurl = environment.approveDownloadPath;
    this.dft_icn = environment.default_temp;
    let userrId = localStorage.getItem('roleId');
    this.userRId = this.UserService.decryptData(userrId);
    this.getOrderDetails();
  }

  getOrderDetails() {
    let data = {
      "OrderInfoId": this.id,
      "SearchWord": this.searchword,
    };
    this.spinner.show();
    this.UserService.GetOrderReviewPDFById(data).subscribe((res) => {
      if (res['result'] == 'success') {
        this.spinner.hide();
        this.orderdoc = res["ApprovedPdf"];
      }
      else if (res['result'] == 'Failed') {
        this.toastr.error(res['Msg']);
        this.spinner.hide();
      } else {
        this.toastr.error(res['Msg']);
        this.spinner.hide();
      }
    }, (err) => {
      this.spinner.hide();
      if (err && (err.Msg || err.Message)) {
        this.toastr.error(err.Msg || err.Message);
      }   
    });
  }

  deleteOpenModal(template: TemplateRef<any>, data) {
    if (data) {
      this.filesid = data.FileId;
      this.filesname = data.FileName;
      this.modalRef = this.modalService.show(template, { class: 'modal-sm modal-dialog-centered' });
    }
  }

  deleteConfirm() {
    this.deletefileinfo();
    this.modalRef.hide();
  }

  deletefileinfo() {
    this.delNameDel = true;
    let Data = {
      OrderInfoId: this.id,
      FileId: this.filesid
    }
    this.spinner.show();
    this.UserService.RemoveOrderPDF(Data).subscribe(
      res => {
        this.delNameDel = false;
        if (res && res['result'] == "success") {
          this.modalRef.hide();
          this.spinner.hide();
          this.ngOnInit();
          this.toastr.success(res['Msg'], 'Success!',);
        }
      }, (err) => {
        this.delNameDel = false;
        if (err && (err.Msg || err.Message)) {
          this.toastr.error(err.Msg || err.Message);
          this.modalRef.hide();
          this.spinner.hide();
        }
      }
    );
  }

  detailOpenModal(template: TemplateRef<any>, data) {
    if (data) {
      this.filesname = data.FileName;
      this.createdBy = data.CreatedBy;
      this.createdDate = data.CreatedDate;
      this.createdTime = data.CreatedTime;
      this.modalRef = this.modalService.show(template, { class: 'modal-sm modal-dialog-centered' });
    }
  }

  detailConfirm() {
    this.modalRef.hide();
  }

  decline() {
    this.modalRef.hide();
  }

  downloadModal(template: TemplateRef<any>, name, data, show) {
    if (data) {
      this.file = data;
      this.filesname = name;
      this.pdfname = show;
      this.modalRef = this.modalService.show(template, { class: 'modal-sm modal-dialog-centered' });
    }
  }

  downloadConfirm() {
    this.download();
    this.modalRef.hide();
  }

  download(): any {
    window.open(this.file);
  }

  clearUserData() {
    const previousValue = this.searchword;
    this.searchword = '';
    if (previousValue && previousValue.length > 0 && previousValue !== this.searchword) {
      this.clearEvent.emit();
    }
  }

}
